import { IKey, ISearchPageField, ITimeRangeType, ITimeRangeVo } from "@/types/ScmTypes";
import {
    AccountLogTypeEnum,
    AccountStatusEnum,
    AdjustStatusEnum,
    CreditFlagEnum,
    UserTypeEnum,
    RechargeStatusEnum, TransferStatusEnum
} from "../../types/ScmEnums";
import { IVRMCustomerDetail } from "../base/customerFiles/customer/baseCustomerService";
import { IVRMSupplierDetail } from "../base/supplier/supplierService";
import React, { Key } from "react";

import { IMdCustomerDetail, IMdSupplierDetail } from "@/types/FmsCustomerTypes";

export interface IAccountSummary {
    totalUsedAmount?: number;
    totalCreditAmount?: number;
    totalRemainingAmount?: number;
    totalDebtAmount?: number;
    totalAvailableAmount?: number;
    accountSummaryVo?: IAccountSummaryShop;
}
export interface IAccountSummaryShop {
    totalAvailableAmount?: number
    totalCreditAmount?: number
    totalDebtAmount?: number
    totalRemainingAmount?: number
    totalUsedAmount?: number
}
export type ICustomerAccountSummary = IMdCustomerDetail & IAccountSummary;

export type ISupplierAccountSummary = IMdSupplierDetail & IAccountSummary;
// export interface ICustomerAccountSummary
//     extends IMdCustomerDetail, IAccountSummary {
//
// }

// export interface ISupplierAccountSummary
//     extends IMdSupplierDetail, IAccountSummary {
// }

export interface IAccountOne {
    code: string;
}

export interface IAccountAdjustSubmit {
    code: string;
}

export interface IAccountAdjustApproval {
    code?: string;
    status?: 2 | 3 | 8;
    approver?: string;
    note?: string;
}
export interface IAccountRechargeApproval {
    code?: string;
    status?: 8 | 1 | 3;
    note?: string;
    approver?: string;
}

export interface IAccountFields {
    accountTypeCode?: string
    code?: string;
    branch?: string;
    name?: string;
    orgCode?: string;
    orgName?: string;
    beCode?: string;
    beName?: string;
    partnerTypeCode?: UserTypeEnum;
    partnerCode?: React.Key;
    partnerName?: string;
    creditFlag?: CreditFlagEnum;
    categoryCode?: string;
    categoryName?: string;
    creditAmount?: number;
    usedAmount?: number;
    availableAmount?: number;
    status?: AccountStatusEnum;
    node?: string;
    shopCode?: string
}

export type IAccountDetail = IKey & IAccountFields;
export type IAccountSearch = IAccountFields & ISearchPageField;


export interface IAccountAdjustFields {
    branch?: string;
    code?: string;
    partnerTypeCode?: UserTypeEnum;
    partnerCode?: Key;
    partnerName?: string;
    accountCode?: string;
    creditAmount?: number;
    adjustAmount?: number;
    status?: AdjustStatusEnum;
    note?: string;
    adjustTimeRange?: ITimeRangeVo;
    shopCode?: string
    md5?: string
    [key: string]: any
}

export type IAccountAdjustDetail = IKey & IAccountAdjustFields;
export type IAccountAdjustSearch = IAccountAdjustFields & ISearchPageField;
export type IAccountAdjustSearchParam = IAccountAdjustFields & ITimeRangeType;

export interface IAccountRechargeFields {
    branch?: string;
    code?: string;
    partnerTypeCode?: UserTypeEnum;
    partnerCode?: Key;
    partnerName?: string;
    accountCode?: string;
    remainingAmount?: number;
    rechargeAmount?: number;
    payMethodCode?: string;
    payMethodName?: string;
    operator?: string;
    creditFlag?: number;
    md5?: string;
    fileName?: string;
    fileSize?: number;
    status?: RechargeStatusEnum;
    note?: string;
    rechargeTimeRange?: ITimeRangeVo;
    shopCode?: string,
    statusList?: string;

}

export type IAccountRechargeDetail = IKey & IAccountRechargeFields;
export type IAccountRechargeSearch = IAccountRechargeFields & ISearchPageField;
export type IAccountRechargeSearchParam = IAccountRechargeFields & ITimeRangeType;

export interface IAccountTransferFields {
    branch?: string;
    code?: string;
    partnerTypeCode?: UserTypeEnum;
    partnerOutCode?: React.Key;
    partnerOutName?: string;
    accountOutCode?: string;
    accountOutAmount?: number;
    partnerInCode?: React.Key;
    partnerInName?: string;
    accountInCode?: string;
    accountInAmount?: number;
    transferAmount?: number;
    status?: TransferStatusEnum;
    note?: string;
    transferTimeRange?: ITimeRangeVo;
    shopCode?: string;
}

export type IAccountTransferDetail = IKey & IAccountTransferFields;
export type IAccountTransferSearch = IAccountTransferFields & ISearchPageField;
export type IAccountTransferSearchParam = IAccountTransferFields & ITimeRangeType;
// 核销类型
export enum WriteoffTypeEnum {
    ONE_BILL,      //"单账单核销")
    ACCOUNT,       //"按账户自动核销")
    MULTI_BILL,    //"多账单核销")
}
export interface IAccountWriteoffFields {
    writeoffType?: WriteoffTypeEnum;
    accountCode?: string;
    partnerTypeCode?: UserTypeEnum;
    partnerCode?: string;
    timeAsc?: number;
    mostAvailable?: number;
    billCode?: string;
    billCodes?: string;
    writeoffTimeRange?: ITimeRangeVo;
    shopCode?: string
}

export type IAccountWriteoffDetail = IKey & IAccountWriteoffFields;
export type IAccountWriteoffSearch = IAccountWriteoffFields & ISearchPageField;
export type IAccountWriteoffSearchParam = IAccountWriteoffFields & ITimeRangeType;


export interface IAccountLogFields {
    branch?: string;
    code?: string;
    partnerTypeCode?: UserTypeEnum;
    partnerCode?: React.Key;
    accountCode?: string;
    logType?: AccountLogTypeEnum;
    linkCode?: string;
    logContent?: string;
    logTime?: string;
    result?: number;
    operator?: string;
    note?: string;
    logTimeRange?: ITimeRangeVo;
    shopCode?: string;
}

export type IAccountLogDetail = IKey & IAccountLogFields;
export type IAccountLogSearch = IAccountLogFields & ISearchPageField;
export type IAccountLogSearchParam = IAccountLogFields & ITimeRangeType;


export interface IAccountWriteoffFields {
    branch?: string;
    code?: string;
}


export interface IAccountType {
    abatementAmount?: string,           // null
    accountTypeCode?: string,           // "account-type.credit"
    accountTypeName?: string,           // "授信账户"
    availableAmount?: number,           // 0
    beCode?: string,           // "dhzd33"
    beName?: string,           // "德恒直达3"
    branch?: string,           // "ci"
    categoryCode?: string,           // null
    categoryName?: string,           // null
    code?: string,           // "ACC-PfeH-00000016"
    createTime?: string,           // "2021-02-20 14?:string,           //59?:string,           //43"
    creditAmount?: number,           // 0
    creditFlag?: number,           // 1
    key?: string,           // "3b1f307f1247fc58f49d69320e93238c"
    name?: string,           // "测试5"
    note?: string,           // null
    orgCode?: string,           // "yh.auto-service.pioneer"
    orgName?: string,           // "云豪创业空间"
    partnerCode?: string,           // "CUS-M-00000005"
    partnerName?: string,           // "上海繁沃汽车服务有限公司"
    partnerTypeCode?: string,           // "user-type.customer"
    remainingAmount?: number,           // 0
    status?: number,           // 0
    usedAmount?: number,           // 0
}
//账户初始化
export interface IFMSInitAccountFields {
    "creditFlag"?: string | number,
    "branch"?: string,
    "accountTypeCode"?: string,
    "accountTypeName"?: string,
    "orgCode"?: string,
    "orgName"?: string,
    "beCode"?: string,
    "beName"?: string,
    [key: string]: any
}

export interface ISCMInitCustomer {
    "code": string,
    "name": string
}

export interface IFMSInitAccountForm {
    type: "0" | "1",  //"0"是客户  ”1“ 是供应商
    fmsAccounts: IFMSInitAccountFields[],
    mdCustomers: ISCMInitCustomer[]
}
/**
 * 消息类型
 */
export enum RechangeMsgEnum {
    RECHANGE, // 充值
    ADJUST, // 调额
}
/**
 * 充值消息
 */
export interface IRechangeMsgFields {
    accountCode: string;
    accountName: string;
    branch: string;
    createTime: string;
    createUser: string;
    id: string;
    note: string;
    partnerCode: string;
    partnerName: string;
    partnerTypeCode: "user-type.supplier" | "user-type.customer";
    code: string;
    shopCode: string;
    shopName: string;
    status: number; // 0 未审核 1 已审核
    type: RechangeMsgEnum; // 0 充值 1 调额
    updateTime: string;
    updateUser: string;
    shopCodes: string[];
}

export type IRechangeMsgDetail = Partial<IKey & IRechangeMsgFields>;
export type IRechangeMsgSearch = IRechangeMsgDetail & ISearchPageField;
export type IRechangeMsgSearchParam = IRechangeMsgDetail & ITimeRangeType;